module.exports = __webpack_public_path__ + "img/1589699626.7b0ae1fe.jpg";